<template>
  <v-card>
    <v-card-title>
      <div
        style="text-align: center; width: 100%;"
        class="text-xs-center headline primary--text"
      >
        {{
          textoTela()
        }}
      </div>
    </v-card-title>
    <v-bottom-nav
      :active.sync="teste"
      color="primary"
      :value="true"
      dark
      shift
    >
      <v-btn dark @click="step = 1">
        <span>Rede</span>
        <v-icon>ac_unit</v-icon>
      </v-btn>

      <v-btn dark @click="step = 2">
        <span>Postos</span>
        <v-icon>local_gas_station</v-icon>
      </v-btn>

      <v-btn dark @click="step = 3">
        <span>Representante</span>
        <v-icon>account_circle</v-icon>
      </v-btn>

    </v-bottom-nav>
    <v-card-text>
      <v-container fluid grid-list-md>
        <v-stepper v-model="step" style="box-shadow: none;">
          <v-stepper-items>
            <v-stepper-content step='1' class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    label="Nome da Rede"
                    v-model="rede.nome"
                    outline
                    hide-details
                  />
                </v-flex>
                <v-flex xs12 md12 class="mt-4">
                  <v-select
                    :items="[
                      { text: 'Padrão', value: 0 },
                      { text: 'Sindicato', value: 1 },
                    ]"
                    outline
                    label="Tipo da Rede"
                    v-model="rede.tipo_rede"
                    />
                </v-flex>
                <v-flex xs12 md12>
                  <v-select
                    :items="postosDaRede"
                    outline
                    label="Posto matriz"
                    item-value="cnpj"
                    item-text="nome_fantasia"
                    v-model="matriz"
                  />
                </v-flex>
                <v-flex xs12 align-self-center class="mt-3">
                  <v-tooltip bottom>
                    <v-btn
                      slot="activator"
                      round
                      outline
                      block
                      @click="rede.ativo = !rede.ativo"
                      :color="rede.ativo ? 'green darken-2': 'red darken-2'"
                    >
                      <template v-if="rede.ativo">ATIVO</template>
                      <template v-else>INATIVO</template>
                    </v-btn>
                    <template v-if="rede.ativo">Clique para desativar</template>
                    <template v-else>Clique para ativar</template>
                  </v-tooltip>
                  <v-btn
                    slot="activator"
                    round
                    outline
                    block
                    @click="rede.is_white_label = !rede.is_white_label"
                    :color="rede.is_white_label ? 'red darken-2' : 'green darken-2'"
                  >
                    {{
                      rede.is_white_label ?
                      'Desativar White Label'
                      :
                      'Ativar White Label'
                    }}
                  </v-btn>
                  <v-btn
                    :disabled="!rede.is_white_label"
                    round
                    outline
                    block
                    @click="rede.is_simultaneo = !rede.is_simultaneo"
                    :color="rede.is_simultaneo ? 'red darken-2' : 'green darken-2'"
                  >
                    {{
                      rede.is_simultaneo ?
                      'Desativar uso simultâneo'
                      :
                      'Ativar uso simultâneo'
                    }}
                  </v-btn>
                   <v-btn
                    :disabled="!rede.is_white_label"
                    round
                    outline
                    block
                    @click="rede.assinatura_sindicato = !rede.assinatura_sindicato"
                    :color="rede.assinatura_sindicato ? 'red darken-2' : 'green darken-2'"
                  >
                    {{
                      rede.assinatura_sindicato ?
                      'Desativar assinatura'
                      :
                      'Ativar uso da assinatura'
                    }}
                  </v-btn>
                  <v-btn
                    :disabled="!rede.is_white_label"
                    round
                    outline
                    block
                    @click="rede.tem_cashback = !rede.tem_cashback"
                    :color="rede.tem_cashback ? 'red darken-2' : 'green darken-2'"
                  >
                    {{
                      rede.tem_cashback ?
                      'Desativar uso de cashback'
                      :
                      'Ativar uso de cashback'
                    }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step='2' class="pa-0">
              <v-layout row wrap justify-space-between class="pa-2">
                  <v-flex xs6>
                      <h4 class="text-xs-center">Postos sem rede</h4>
                      <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;"  class="mr-1">
                          <v-list-tile v-for="(posto, index) in postosSemRede" :key="index" ripple @click="inserirEmRede(posto, index)">
                              <v-list-tile-avatar>
                                  <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                  <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                  <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="postosSemRede.length === 0">
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                  </v-flex>
                  <v-flex xs6>
                      <h4 class="text-xs-center">Postos da rede</h4>
                      <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em" class="ml-1">
                          <v-list-tile v-for="(posto, index) in postosDaRede" :key="index" ripple @click="removerDaRede(posto, index)">
                              <v-list-tile-avatar>
                                  <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                  <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                  <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="postosDaRede.length === 0">
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                  </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step='3' class="pa-0">
              <v-layout row wrap v-if="representante">
                <v-flex xs6>
                  <v-text-field
                    label="Nome do Representante"
                    v-model="representante.nome"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Nome do Representante"
                    v-model="representante.sobrenome"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    mask="###.###.###-##"
                    label="CPF do Representante"
                    v-model="representante.cpf"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Email do Representante"
                    v-model="representante.email"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    mask="(##) # ####-####"
                    label="Telefone do Representante"
                    v-model="representante.telefone"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="verificacaoTelefone.cadastrado || (verificacaoTelefone.pessoa && representante && verificacaoTelefone.pessoa.id_pessoa !=  representante.id_pessoa)">
                  <v-card class="ma-2" elevation="4">
                    <v-card-title class="justify-center">
                      <h4
                        v-if="verificacaoTelefone.cadastrado || verificacaoTelefone.pessoa"
                        class="text-xs-center error--text"
                      >
                        Esse telefone já foi cadastrado
                      </h4>
                    </v-card-title>
                    <v-card-text>
                      <v-flex
                        class="error--text"
                        v-if="verificacaoTelefone.quantidade > 0"
                      >
                        {{ verificacaoTelefone.quantidade }} {{ verificacaoTelefone.quantidade === 1 ? 'pessoa cadastrou esse telefone' : 'pessoas cadastraram esse telefone' }}
                      </v-flex>
                      <v-flex
                        class="error--text"
                        v-if="verificacaoTelefone.ids_cadastrados.length > 0"
                      >
                        IDs que registraram esse telefone: <span v-for="(fone, index) in verificacaoTelefone.ids_cadastrados" :key="index">
                          {{ fone }}<span v-if="index < verificacaoTelefone.ids_cadastrados.length - 1 ">,</span>
                        </span>
                      </v-flex>
                      <v-layout wrap justify-space-between v-if="verificacaoTelefone.pessoa" class="error--text">
                        <v-flex xs12><h4 class="text-xs-center">Cadastro Firebase</h4></v-flex>
                        <v-flex xs11>Nome: {{ verificacaoTelefone.pessoa.nome_completo }}</v-flex>
                        <v-flex xs5>CPF: {{ verificacaoTelefone.pessoa.cpf }}</v-flex>
                        <v-flex xs5>ID: {{ verificacaoTelefone.pessoa.id_pessoa }}</v-flex>
                        <v-flex xs11>E-mail: {{ verificacaoTelefone.pessoa.email }}</v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-btn block round small color="secondary" @click="cardSmartlock = !cardSmartlock">
                      <v-icon style="margin-right: 3px;">{{cardSmartlock ? 'close' : 'password'}}</v-icon>
                      {{cardSmartlock ? '' : 'Smartlock'}}
                  </v-btn>
                  <v-card elevation="5" v-show="cardSmartlock" class="ml-4 mr-4 mt-2 mb-3">
                      <v-card-title style="font-size: 1.3em;">Cadastrar Smartlock</v-card-title>
                      <v-card-text>
                          <v-text-field
                              label="Digite o novo smartlock"
                              v-model="smartlock"
                              placeholder="******"
                              :type="show ? 'text' : 'password'"
                              :append-icon="show ? 'visibility' : 'visibility_off'"
                              @click:append="show = !show"
                              :min="4"
                              autocomplete="off"
                              single-line
                          ></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                          <v-btn
                            color="secondary"
                            block
                            @click="cadastrarSmartlock"
                            :disabled="!smartlock || smartlock < 4"
                            :loading="loading"
                          >
                              <v-icon class="mr-1">save</v-icon>
                              Salvar
                          </v-btn>
                      </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn
        flat
        color="grey darken-2"
        @click="$emit('fechar')"
      >
        Voltar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        flat
        color="green"
        @click="function () {
          if (step === 1) {
            editar()
          } else if (step === 2) {
            inserirPostosNaRede()
          } else {
            editarDadosPessoais()
          }
        }"
        :loading="loading"
        :disabled="step==3 && !representante"
      >
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: ['rede'],
  data () {
    return {
      teste: 0,
      step: 1,
      postosDaRede: [],
      postosSemRede: [],
      matriz: undefined,
      representante: undefined,
      cardSmartlock: false,
      show: false,
      smartlock: '',
      verificacaoTelefone: {
        cadastrado: false,
        quantidade: 0,
        ids_cadastrados: [],
        pessoa: undefined
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  beforeMount () {
    if (this.rede) {
      this.representante = this.rede.representante
      this.matriz = this.rede.matriz ? this.rede.matriz.cnpj : undefined
      this.pegarPostoDaRede()
    } else {
      this.representante = undefined
      this.matriz = undefined
    }
  },
  watch: {
    step (val) {
      if (val === 2) this.pegarPostoSemRede()
    },
    'representante.telefone' (val) {
      if (val && val.length === 11) {
        this.verificarTelefone()
      } else {
        this.verificacaoTelefone.pessoa = undefined
        this.verificacaoTelefone.ids_cadastrados = []
        this.verificacaoTelefone.cadastrado = false
        this.verificacaoTelefone.quantidade = 0
      }
    }
  },
  methods: {
    textoTela () {
      switch (this.step) {
        case 1:
          return 'Editando Dados da Rede'
          case 2:
            return 'Postos da Rede'
          case 3:
            return 'Editando Dados do Representante'
      }
    },
    editar () {
      this.$store.dispatch('atualizarTudoRede', {
        id_rede: this.rede.id_rede,
        nome: this.rede.nome,
        tipo_rede: this.rede.tipo_rede,
        matriz: this.matriz ? this.matriz : null,
        is_simultaneo: this.rede.is_simultaneo,
        assinatura_sindicato: this.rede.assinatura_sindicato,
        is_white_label: this.rede.is_white_label,
        ativo: this.rede.ativo,
        tem_cashback: this.rede.tem_cashback
      }).then(() => {
        this.$emit('editado', 'Rede cadastrada com sucesso.')
        this.$emit('carregar')
      })
    },
    pegarPostoDaRede () {
      this.$store.dispatch('pegarPostosPorRede', { id: this.rede.id_rede }).then(value => {
        this.postosDaRede = value.slice()
      })
    },
    inserirEmRede (posto, index) {
      this.postosDaRede.push(posto)
      this.postosSemRede.splice(index, 1)
    },
    removerDaRede (posto, index) {
      this.postosSemRede.push(posto)
      this.postosDaRede.splice(index, 1)
    },
    pegarPostoSemRede () {
      const data = {
        is_admin: true,
        tipo_rede: this.rede.tipo_rede
      }
      if (this.representante && this.rede.tipo_rede !== 1) {
        data.id_pessoa = this.representante.id_pessoa
      }
      this.$store.dispatch('postosSemRede', data).then(value => {
        this.postosSemRede = value.slice()
      })
    },
    inserirPostosNaRede () {
      if (this.postosDaRede.length < 2 && this.rede.is_white_label) {
        alert('Quantidade de postos é insuficientes.')
        return
      }
      let lista = []
      this.postosDaRede.map(posto => {
        lista.push(posto.cnpj)
      })
      this.$store.dispatch('inserirEmRede', {
        lista: this.postosDaRede.map(posto => posto.cnpj),
        id_rede: this.rede.id_rede
      }).then(() => {
        this.$store.dispatch('carregar')
        this.$emit('editado', 'Os postos que compõem a rede foram alterados')
      })
    },
    cadastrarSmartlock () {
      this.$store.dispatch('cadSmartLockPessoa', {
        smartlock: this.smartlock,
        id_pessoa: this.representante.id_pessoa
      }).then(() => {
        this.cardSmartlock = false
        this.smartlock = ''
        this.$emit('editado', 'Smartlock cadastrado com sucesso')
      }).catch(() => {
          this.$emit('error', 'Não foi possível cadastrar Smartlock')
      })
    },
    verificarTelefone () {
      this.$store.dispatch('verificarTelefone', {
        id_pessoa: this.representante.id_pessoa,
        telefone: this.representante.telefone.slice(3, 11)
      }).then(json => {
        this.verificacaoTelefone = json
      })
    },
    editarDadosPessoais () {
      this.$store
      .dispatch('updatePessoa', {
        id_pessoa: this.representante.id_pessoa,
        nome: this.representante.nome,
        sobrenome: this.representante.sobrenome,
        cpf: this.representante.cpf,
        telefone: this.representante.telefone ? this.representante.telefone : null,
        deletar_telefone: !this.representante.telefone,
        email: this.representante.email
      }).then(() => {
        this.$emit('editado', 'Dados pessoais do representante atualizados com sucesso.')
      }).catch(() => {
        this.$emit('editado', 'Não foi possível atualizar os Dados pessoais do representante.')
      })
    }
  }
}
</script>
